// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"f055b93e","239":"60216727","344":"abdcfa4f","451":"60a6b6ed","455":"19fdf6e3","809":"b1dc1699","977":"ffd0d9da"}[chunkId] + ".chunk.js";
};